import { reviewsFormat } from '@/pages/opinion/utils/value';
import { channelColorTextMap } from '../constants';
import moment from 'moment';
import { channelInfo } from '@/pages/opinion/components/ChannelLabel';
import {
  ChartItemType,
  arrayToObj,
  dateTypeMap,
  getAllNameList,
  getPercentage,
  getPercentageValue,
  getTimeSpaceArray,
  pressTimeGrouping,
} from '@/pages/opinion/utils';
import { ServerTimeType } from '@/pages/opinion/components/FilterCommon/types';
import { MutableRefObject, RefObject } from 'react';
import { paramsToMomentMap } from '@/pages/opinion/utils/time';
import {
  formatChartParamsDate,
  listTimeTitleFunc,
} from '@/pages/opinion/components/ChartCommon/formatter';

// 图表提示框
export const echartsFormatterFunc = (
  originalParam: any[],
  splitText?: string,
  type?: string,
  noShare?: boolean,
  metric?: string,
  shareTitle?: string,
  sumText?: string,
  dateType?: ServerTimeType,
  formatMessage?: any,
) => {
  let letTitle = '';

  // 计算total
  let total = 0;
  let param = originalParam?.filter(item => item.seriesName !== 'total总数');

  param?.forEach(item => {
    let { axisValue, value } = item || {};
    if (!letTitle) {
      letTitle = listTimeTitleFunc(axisValue, dateType || 'daily');
    }
    total += value;
  });

  return formatChartParamsDate({
    params: param,
    total,
    isSort: true,
    valueFormat: value => {
      return reviewsFormat(value);
    },
    textShowFun: (marker, listTitle) => {
      if (
        type === 'account' &&
        splitText &&
        listTitle?.toLocaleLowerCase() !== 'others'
      ) {
        const [channel, newName] = listTitle?.split(splitText) || [];
        const { img, name } = channelInfo(channel as any);
        const finalName = newName.replace(channel, name);
        return `<span class="chart-common-formatter-marker">${marker}<img src=${img} style="width: 16px; height: 16px;"/> </span>&nbsp;${finalName}`;
      }
      if (listTitle?.toLocaleLowerCase() === 'others' && formatMessage) {
        return `<span class="chart-common-formatter-marker">${marker}</span>&nbsp;${formatMessage?.(
          { id: 'Others' },
        )}`;
      }
      const { name } = channelInfo(listTitle as any);
      return `<span class="chart-common-formatter-marker">${marker}</span>&nbsp;${name}`;
    },
    recordDealwith: (rows, ele) => {
      let { value } = ele || {};
      if (!noShare) {
        rows['share'] = getPercentage(value || 0, total);
      }
      return rows;
    },
    dealwithRecords(records, total) {
      let obj: any = {
        text: sumText,
        value: reviewsFormat(total),
      };
      if (!noShare) {
        obj['share'] = '100%';
      }
      records.unshift(obj);
    },
    tablesConfigFunc: (records: Array<any>) => {
      let result = [
        {
          showHeader: true,
          records,
          columns: [
            {
              key: 'text',
              header: letTitle,
            },
            {
              key: 'value',
              align: 'right',
              weight: 'bold',
              header: metric,
            },
          ],
        },
      ];

      if (!noShare) {
        result[0].columns.push({
          key: 'share',
          align: 'right',
          weight: 'bold',
          header: shareTitle,
        });
      }

      return result;
    },
  });
};

type CommonDataItemType = {
  date: string;
  followers_number?: number;
  channel: string;
  value: number;
  channelText?: string;
  share?: string;
};

export type CommonDataType = Array<CommonDataItemType>;

type InterfaceDataType = Array<{
  x_axis: string;
  y_axis: Array<{ [key: string]: string }>;
}>;
/**
 * 将数据转化为日期为key的数据，这样处理后续表格数据也方便展示
 * @param commonData
 * @returns
 */
export function commonToDateMap(commonData: InterfaceDataType) {
  let dateMap: any = {};
  commonData?.forEach(({ x_axis, y_axis }) => {
    if (!dateMap[x_axis]) {
      dateMap[x_axis] = [];
    }
    for (const key in y_axis) {
      if (Object.prototype.hasOwnProperty.call(y_axis, key)) {
        const element = y_axis[key];
        dateMap[x_axis].push({
          value: element,
          date: x_axis,
          channel: key,
          channelText: channelColorTextMap[key]?.legendName || 'Others',
        });
      }
    }
  });
  return dateMap;
}

/**
 * 将数据转化为日期为key的数据，这样处理后续表格数据也方便展示
 * @param commonData
 * @returns
 */
export function dateMapToGrowthData(dateMap: {
  [key: string]: CommonDataItemType;
}) {
  // 提前将数据转化为正确数据

  return dateMap;
}

/**
 * 上两个图表数据处理方法，添加缺失数据,并计算share值
 * @param dateMap      经过followerToDateMap处理后的日期数据
 * @param start_time   开始时间
 * @param end_time     结束时间
 * @param date_type    日期类型
 * @returns
 */
export function dealwithCommonData(
  dateMap: { [key: string]: CommonDataType },
  start_time: string,
  end_time: string,
  date_type: ServerTimeType,
) {
  const xAxisData: Array<string> = [];
  let seriesDataArray: Array<{
    data: Array<number>;
    color: string;
    legendName: string;
  }> = [];
  const records: any = [];
  // 补充缺失的渠道数据
  const dataMap: {
    [key: string]: { data: Array<number>; color: string; legendName: string };
  } = {};
  // 获取时间间隔，以时间去取数据
  const dateType = dateTypeMap[date_type];
  const format = dateType === 'hour' ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
  const dateList = getTimeSpaceArray(start_time, end_time, dateType, format);

  dateList.forEach(key => {
    const keys = Object.keys(channelColorTextMap);
    const dataArr = dateMap[key];
    const sum =
      dataArr?.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.value;
      }, 0) || 0;
    xAxisData.push(key);
    keys.forEach(channelKey => {
      const itemInfo = dataArr?.find(item => item.channel === channelKey);
      if (!dataMap[channelKey]) {
        dataMap[channelKey] = {
          data: [],
          ...(channelColorTextMap[channelKey] || {}),
        };
      }
      if (itemInfo) {
        dataMap[channelKey].data.push(itemInfo.value);
        itemInfo['share'] = getPercentage(itemInfo.value, sum, 1);
        records.push(itemInfo);
      } else {
        dataMap[channelKey].data.push(0);
      }
    });
  });
  seriesDataArray = Object.values(dataMap).flat(Infinity);
  return { seriesDataArray, records, xAxisData };
  // 可能还需要补充缺失的时间数据，看后端处理
}

/**
 * 下两个图表数据处理方法，添加缺失数据,并计算share值
 * @param dateMap      经过followerToDateMap处理后的日期数据
 * @param start_time   开始时间
 * @param end_time     结束时间
 * @param date_type    日期类型
 * @returns
 */
export function dealwithGrowthData(
  dateMap: { [key: string]: CommonDataType },
  start_time: string,
  end_time: string,
  date_type: ServerTimeType,
) {
  const xAxisData: Array<string> = [];
  let seriesDataArray: Array<{
    data: Array<number>;
    color: string;
    legendName: string;
  }> = [];
  const records: CommonDataType = [];
  // 补充缺失的渠道数据
  const dataMap: {
    [key: string]: { data: Array<number>; color: string; legendName: string };
  } = {};

  // 获取时间间隔，以时间去取数据
  const dateType = dateTypeMap[date_type];
  const format = dateType === 'hour' ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
  const dateList = getTimeSpaceArray(start_time, end_time, dateType, format);

  dateList.forEach(key => {
    const keys = Object.keys(channelColorTextMap);
    const dataArr = dateMap[key];
    const sum =
      dataArr?.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.value;
      }, 0) || 0;
    xAxisData.push(key);
    keys.forEach(channelKey => {
      const itemInfo = dataArr?.find(item => item.channel === channelKey);
      if (!dataMap[channelKey]) {
        dataMap[channelKey] = {
          data: [],
          ...(channelColorTextMap[channelKey] || {}),
        };
      }
      if (itemInfo) {
        dataMap[channelKey].data.push(itemInfo.value);
        itemInfo['share'] = getPercentage(itemInfo.value, sum, 1);
        records.push(itemInfo);
      } else {
        dataMap[channelKey].data.push(0);
      }
    });
  });
  seriesDataArray = Object.values(dataMap).flat(Infinity);
  return { seriesDataArray, records, xAxisData };
  // 可能还需要补充缺失的时间数据，看后端处理
}

type FollowersDataType = {
  timeline_of_start_time: string;
  timeline_of_end_time: string;
  date_type: ServerTimeType;
  list: InterfaceDataType;
};

export function dealwithFlowersData({
  list,
  timeline_of_start_time,
  timeline_of_end_time,
  date_type,
}: FollowersDataType) {
  const dateMap = commonToDateMap(list);
  const { seriesDataArray, records, xAxisData } = dealwithCommonData(
    dateMap,
    timeline_of_start_time,
    timeline_of_end_time,
    date_type,
  );
  // 转为图表可用数据
  return {
    xAxisData,
    seriesDataArray,
    records,
  };
}

export function legendIcon(name: string, color: string) {
  return 'circle';
}

export function handleContentScroll(
  defaultElement: any,
  elements: string | any[],
  contentRef: MutableRefObject<any>,
  offset = 100,
) {
  let curOffsetElement = defaultElement;
  for (let index = 0; index < elements.length; index += 1) {
    const element = elements[index];
    const anchorElement = document.getElementById(element);
    if (!(anchorElement instanceof HTMLElement)) {
      continue;
    }
    if (!(contentRef.current instanceof HTMLElement)) {
      continue;
    }
    const curScrollTop = contentRef.current.scrollTop;
    if (curScrollTop >= anchorElement.offsetTop - offset) {
      curOffsetElement = element;
    }
  }
  return curOffsetElement;
}

export function handleNavigatorScroll(
  curNavigator: string,
  contentRef: RefObject<HTMLElement>,
  offset = 100,
) {
  const anchorElement = document.getElementById(curNavigator);
  if (!(anchorElement instanceof HTMLElement)) {
    return;
  }
  if (!(contentRef.current instanceof HTMLElement)) {
    return;
  }
  contentRef.current.scrollTo({
    top: anchorElement?.offsetTop - offset,
    behavior: 'smooth',
  });
}

// 将图表数据处理为表格数据
export function dealwithTableCommentData(
  basic_data: Array<ChartItemType>,
  date_type: ServerTimeType,
) {
  const dateType = dateTypeMap[date_type];
  const format = dateType === 'hour' ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
  const timeGroup = pressTimeGrouping(basic_data, format);
  let result: any[] = [];
  const keys = Object.keys(timeGroup || {});
  keys.reverse();
  for (let index = 0; index < keys.length; index++) {
    const element = timeGroup[keys[index]] || [];
    element.sort(
      (a: { value: number }, b: { value: number }) => b.value - a.value,
    );
    const total = element.reduce(
      (pre: any, cur: { value: any }) => cur.value + pre,
      0,
    );
    result = result.concat(
      element.map(
        (item: {
          time: moment.MomentInput;
          key: any;
          name: any;
          value: number;
        }) => ({
          ...item,
          date: moment(item.time).format(format),
          channel: item.key || item.name,
          share: getPercentageValue(item.value, total, 8),
        }),
      ),
    );
  }

  return result;
}

// 将图表数据处理为表格数据
export function dealwithGrowthTableCommentData(
  timeGroup: any,
  date_type: ServerTimeType,
) {
  const dateType = dateTypeMap[date_type];
  const format = dateType === 'hour' ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
  let result: any[] = [];
  const keys = Object.keys(timeGroup || {});
  keys.reverse();
  for (let index = 0; index < keys.length; index++) {
    const element = timeGroup[keys[index]] || [];
    element.sort(
      (a: { value: number }, b: { value: number }) => b.value - a.value,
    );
    const total = element.reduce(
      (pre: any, cur: { value: any }) => (cur.value || 0) + pre,
      0,
    );
    result = result.concat(
      element.map(
        (item: {
          time: moment.MomentInput;
          key: any;
          name: any;
          value: number;
        }) => ({
          ...item,
          date: moment(item.time).format(format),
          channel: item.key || item.name,
          share: getPercentageValue(item.value, total, 8),
          value: item.value,
        }),
      ),
    );
  }
  return result;
}

/**
 * TODO: 其他系统使用
 * 处理图表，表格数据的地方
 * 记住：基础数据会多一天，所以不能使用基础数据去求和等
 * @param start_time     开始时间
 * @param end_time       结束时间
 * @param basic_data     基础列表数据
 * @param date_type      时间类型，涉及到时间分段
 * @param dataType       数据类型，看求和，还是求平均数，还是求最大值
 * @param allKey         所有的key，加入数据里缺少数据就会使用这个处理
 * @returns
 */
export function dealwithGrowthChartRatio(
  start_time: string,
  end_time: string,
  basic_data: Array<ChartItemType>,
  date_type: ServerTimeType,
) {
  const dateType = dateTypeMap[date_type];
  const format = dateType === 'hour' ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
  const dateArr = getTimeSpaceArray(start_time, end_time, dateType, format);
  const allKeyList = getAllNameList(basic_data);
  const timeGroup: any = pressTimeGrouping(basic_data, format);

  const newTimeGroupInfo: any = {};
  for (let index = 0; index < dateArr.length; index++) {
    const newKey = dateArr[index];
    let oldKey = dateArr[index - 1];
    if (index === 0) {
      try {
        // 如果有问题就走这个备用方案，直接当前key - 1天
        oldKey = moment(newKey)
          .subtract(1, paramsToMomentMap[date_type])
          .format(format);
      } catch (error) {
        // 将timeGroup的key排序后取第一个 这个方法在studio项目和舆情项目的表现形式不一致
        oldKey = Object.keys(timeGroup).sort((a, b) =>
          Number(moment(a).isBefore(moment(b))),
        )[0];
      }
    }

    const list: any = [];
    const newInfo = arrayToObj(timeGroup[newKey], 'key');
    const oldInfo = arrayToObj(timeGroup[oldKey], 'key');
    allKeyList.forEach((key: string | number) => {
      const newCount = newInfo[key]?.value || 0;
      const oldCount = oldInfo[key]?.value || 0;
      const value = newCount - oldCount;
      list.push({
        ...newInfo[key],
        new_count: newCount,
        count: value,
        value,
        old_count: oldCount,
        key,
        time: newKey,
        name: key,
      });
    });
    newTimeGroupInfo[newKey] = list;
  }
  const list = dealwithGrowthTableCommentData(newTimeGroupInfo, date_type);

  return { timeGroupInfo: newTimeGroupInfo, table: list };
}
